<script setup lang="ts">
import { h } from 'vue';
import { toRefs, watchEffect } from 'vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import icons from './icons';
import { AksInsertAiContentButton, PLUGIN_KEY } from './config';
import { EditorInteractionManager, ImageCdnService, UseDrawerComposableService } from '../types';
import AiContentDrawer from './ai-content-drawer.vue';
import { CaptureErrorFunc } from '../../use-error-logger';

defineOptions({ name: 'AksInsertProductCardPlugin' });

const emit = defineEmits(['toolbarButtonClicked', 'contentInserted'])

const props = defineProps<{
  id: string;
  editorInteractionManager: EditorInteractionManager;
  useDrawerService: UseDrawerComposableService;
  imageCdnService: ImageCdnService;
  captureError: CaptureErrorFunc;
}>();

const { id, editorInteractionManager: im, imageCdnService, captureError } = toRefs(props);
const { t } = useI18n();

const aiContentDrawer = props.useDrawerService();

const pluginId = computed(() => id.value + '_' + PLUGIN_KEY);

const register = () => {
  im.value.registerPlugin(pluginId.value, ({ addButton, addIcons }) => {
      addIcons(icons);

      addButton(AksInsertAiContentButton.InsertAiContent, {
        text: t('account.brands.createCampaigns.editor.toolbar.insertAiContent.label'),
        icon: 'stars',
        onAction: () => {
          openAiContentDrawer();
          emit('toolbarButtonClicked', PLUGIN_KEY);
        }
      });
    });
};

const handleSubmit = (result: Record<string, string>) => {
  emit('contentInserted', result, PLUGIN_KEY);

  closeAiContentDrawer();
};

const openAiContentDrawer = async () => {
  const props = {
    onSubmit: handleSubmit,
    onClose: closeAiContentDrawer,
    imageCdnService: imageCdnService.value,
    captureError: captureError.value,
  };

  aiContentDrawer.openDrawer(() => h(AiContentDrawer, props), {
    right: true,
    width: '45%',
    closeOnOutsideClick: false,
  });
};

const closeAiContentDrawer = async () => {
  aiContentDrawer.closeDrawer();
};

watchEffect(() => {
  if (im.value && pluginId.value) {
    register();
  }
});

</script>
<template>
  <span />
</template>
